import { updateObjectInArray } from "../Utils/ObjectUtils";
import ActionEnum from "./ActionEnum";
import { EntityTypeEnum } from "./EntityTypeEnum";

const initialState = {
  applicationDTO: {},
  firstHolderData: {},
  secondHolderData: {},
  firstHolderWidgetList: [],
  secondHolderWidgetList: [],
  holderList:[],
  isKycProcessCompleted:false
};

const widgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionEnum.SET_APPLICATION_DATA:
      return {
        ...state,
        applicationDTO: action.data,
      };
    case ActionEnum.UPDATE_FIRST_HOLDER_DATA:
      return {
        ...state,
        firstHolderData: action.data,
      };
    case ActionEnum.UPDATE_SECOND_HOLDER_DATA:
      return {
        ...state,
        secondHolderData: action.data,
      };
    case ActionEnum.UPDATE_FIRST_HOLDER_WIDGET_LIST:
      return {
        ...state,
        firstHolderWidgetList: action.data,
        holderList : getUpdatedHolderList(state,action.data,EntityTypeEnum.FH)
      };
      case ActionEnum.UPDATE_SECOND_HOLDER_WIDGET_LIST:
        return {
          ...state,
          secondHolderWidgetList: action.data,
          holderList : getUpdatedHolderList(state,action.data,EntityTypeEnum.SH)
        };
      case ActionEnum.UPDATE_HOLDER_LIST:
          return {
            ...state,
            holderList: action.data,
          };
      case ActionEnum.UPDATE_IS_KYC_PROCESS_COMPLETED:
          return {
            ...state,
            isKycProcessCompleted: action.data,
          };
    default:
      return state;
  }
};

export default widgetReducer;



const getUpdatedHolderList=(currentState,widgetDTOList, holderType )=>{
  var currentHolderList=currentState.holderList;

  //loop holder and update holder data
  currentHolderList && currentHolderList.map((kycApplicationEntityDTO) => {
    if (kycApplicationEntityDTO.entityTypeShortName === holderType) {

      if (Array.isArray(kycApplicationEntityDTO.kycApplicationWorkflowDTOList)) {
        let currentWorkflowIndex = kycApplicationEntityDTO.kycApplicationWorkflowDTOList.findIndex(
          (obj) => obj.workflowDisplayName === kycApplicationEntityDTO.selectedWorkflowDisplayName
        );
      
        if (currentWorkflowIndex !== -1) {
          kycApplicationEntityDTO.kycApplicationWorkflowDTOList[currentWorkflowIndex].widgetDTOList = widgetDTOList;
        }
      }
    }    
  });

  return currentHolderList;

}
